var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webtab-button-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "webtab-trigger-button",
        on: { click: _vm.toggleWebTabList },
      },
      [
        _c("span", { staticClass: "material-icons webtab-icon" }, [
          _vm._v("tab"),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "custom-dropdown",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "dropdown-content" },
              _vm._l(_vm.webTabs, function (tab) {
                return _c(
                  "div",
                  {
                    directives: [{ name: "tippy", rawName: "v-tippy" }],
                    key: tab._id,
                    staticClass: "webtab-item",
                    attrs: {
                      content: tab.description || tab.name,
                      "data-tippy-placement": "bottom",
                      "data-tippy-theme": "light-border",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectWebTab(tab)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "webtab-icon-wrapper" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons list-icon",
                          style: { color: tab.iconColor || "#6b727d" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(tab.icon || "tab") +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "webtab-name" }, [
                      _vm._v(_vm._s(tab.name)),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "webtab-item create-new",
                on: { click: _vm.createNewWebTab },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("span", { staticClass: "webtab-name" }, [
                  _vm._v("Yeni Web Sekmesi"),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.visible
      ? _c("div", {
          staticClass: "dropdown-backdrop",
          on: {
            click: function ($event) {
              _vm.visible = false
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plus-icon-wrapper" }, [
      _c("span", { staticClass: "plus-icon" }, [_vm._v("+")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }